import { render, staticRenderFns } from "./ReferencesDialog.vue?vue&type=template&id=b304a924"
import script from "./ReferencesDialog.vue?vue&type=script&lang=js"
export * from "./ReferencesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports